export interface AppState {
  userId: string
  userLastName: string
  userFirstName: string
  userRoles: USER_ROLE_TYPES[]
}

export enum USER_ROLE_TYPES {
  // change type of dashboard which is top page
  CARE_TEAM = 'care_team',
  EXEC = 'exec',
  ADMIN = 'admin',
  ROCHE_CONSULTANT = 'roche_consultant',
  NURSING_HOME = 'nursing_home',

  // change type of pateint-stats/*
  COPD_DASH = 'copd_dash', // old 6 graph dashboard
  MULTI_DEV_DASH = 'multi_dev_dash', // all devices dashboard (weight, thermometer, pulse oxi, ...)
  MULTI_DEV_LIMITED_DASH = 'multi_dev_limited_dash', // multi_dev_dash minus pulse oxi graphs
  ACTIVITY_DASH = 'activity_dash',
}
